<div
  class="w-full ef-scrollbar h-fit flex flex-col text-mat-ef-revolution-primary-500 font-efSans overflow-y-auto"
  >
  <div
    class="overflow-y-auto flex-1 h-fit max-h-full md:max-h-[360px] mt-5 gap-3 grid grid-cols-1 md:grid-cols-3"
    >
    @if (document?.invNumber) {
      <div class="text">
        <div class="text-base font-semibold">
          <T
          str="Invoice number"
          key="customerPortal.customer-portal.invoice.invoice-number"
          tags="customer-portal, 3.1"
        ></T>
      </div>
      <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
        {{ document.invNumber }}
      </div>
    </div>
  }

  @if (document?.price) {
    <div class="text">
      <div class="text-base font-semibold">
        <T
        str="Price"
        key="customerPortal.customer-portal.offer-contract.price"
        tags="customer-portal, 3.1"
      ></T>
    </div>
    <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
      @if (showDocumentPrice) {
        <span>
          {{
          document.price | currency: currency:'symbol':'1.2-2':currencyLocale
          }}
        </span>
      } @else {
        <span>-</span>
      }
    </div>
  </div>
}

@if (document?.number) {
  <div class="text">
    <div class="text-base font-semibold">
      <T
      str="ID"
      key="customerPortal.customer-portal.offer-contract.id"
      tags="customer-portal, 3.1"
    ></T>
  </div>
  <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
    {{ document.number }}
  </div>
</div>
}

@if (document?.dateCreated) {
  <div class="text">
    <div class="text-base font-semibold">
      <T
      str="Created on"
      key="customerPortal.customer-portal.offer-contract.created-on"
      tags="customer-portal, 3.1"
    ></T>
  </div>
  <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
    {{ document.dateCreated | date: dateFormat }}
  </div>
</div>
}

@if (document?.createdBy) {
  <div class="text">
    <div class="text-base font-semibold">
      <T
      str="Created by"
      key="customerPortal.customer-portal.offer-contract.created-by"
      tags="customer-portal, 3.1"
    ></T>
  </div>
  <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
    {{ document.createdBy }}
  </div>
</div>
}

@if (document?.contractStatus) {
  <div class="text">
    <div class="text-base font-semibold">
      <T
      str="Status"
      key="customerPortal.customer-portal.offer-contract.status"
      tags="customer-portal, 3.1"
    ></T>
  </div>
  <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
    <ng-container
          *ngTemplateOutlet="
            sharedService.template('transifexTranslation');
            context: {
              str: document.contractType + '.' + document.contractStatus,
              prefix: 'customerPortal.customer-portal.'
            }
          "
  ></ng-container>
</div>
</div>
}

@if (document?.vin) {
  <div class="text">
    <div class="text-base font-semibold">
      <T
      str="VIN"
      key="customerPortal.customer-portal.offer-contract.VIN"
      tags="customer-portal, 3.1"
    ></T>
  </div>
  <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
    {{ document.vin }}
  </div>
</div>
}

@if (document?.brandName) {
  <div class="text">
    <div class="text-base font-semibold">
      {{ 'brand' | sharedTranslate }}
    </div>
    <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
      {{ document.brandName }}
    </div>
  </div>
}

@if (document?.modelName) {
  <div class="text">
    <div class="text-base font-semibold">
      {{ 'model' | sharedTranslate }}
    </div>
    <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
      {{ document.modelName }}
    </div>
  </div>
}

@if (document?.engine) {
  <div class="text">
    <div class="text-base font-semibold">
      <T
      str="Engine"
      key="customerPortal.customer-portal.offer-contract.engine"
      tags="customer-portal, 3.1"
    ></T>
  </div>
  <div class="text-base text-mat-ef-revolution-grey-two-500 font-normal">
    {{ document.engine }}
  </div>
</div>
}
</div>

@if (hasServices(document)) {
  <mat-divider class="divider my-5"></mat-divider>
  @for (s of document?.services; track s) {
    <div>
      <h2 class="text-efSans text-base font-bold text-mat-ef-revolution-primary-500">
        {{ s.name }}
      </h2>
      @for (i of s.items; track i) {
        <div class="font-efSans text-base text-mat-ef-revolution-grey-two-500 font-normal">
          @if (i.description) {
            <span>{{ i.description }}</span>
          }
        </div>
      }
    </div>
  }
}


</div>
